// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from "./AuthContext"; 
import LandingPage from './essentials/LandingPage';
import SlideGenerator from './main-pages/SlideGenerator';
import Header from './essentials/Header';

import PricingPage from './essentials/PricingPage';


import Sharedppt from './main-pages/Sharedppt';
import './App.css';

function App() {
  return (
 
      <AuthProvider>
        <Router>
          <Routes>
            {/* ✅ SHARED VIEW - No Header/Footer, Full Screen */}
            <Route 
              path="/shared/:shareId" 
              element={<Sharedppt />} 
            />

            {/* ✅ ALL OTHER ROUTES - With Header/Footer */}
            <Route path="*" element={
              <div className="App">
                <Header />
                <Routes>
                  <Route path="/" element={<LandingPage />} />
                  <Route path="/generate" element={<SlideGenerator />} />
                  <Route path="/pricing-plans" element={<PricingPage />} />
               
                </Routes>
          
              </div>
            } />
          </Routes>
        </Router>
      </AuthProvider>
    
  );
}

export default App;